export const propertiesProgressHeaders = [
  { content: "" },
  { content: "Plan" },
  { content: "User" },
  { content: "Functional area" },
  { content: "Due date" },
  { content: "Progress" }
];

export const planProgressHeaders = [
  { content: "Inncode" },
  { content: "User" },
  { content: "Status" },
  { content: "Progress" },
  { content: "Engagement" },
  { content: "Priority" },
  { content: "Due Date" },
  { content: "Completion Date" }
];
export const userPlanProgressHeaders = [
  { content: "" },
  { content: "Plan" },
  { content: "Functional area" },
  { content: "Due date" },
  { content: "Status" }
];
